"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/order/wizard");
const _orderFiles = require("../../modules/orderFiles/reducers");
const orderFiles = _orderFiles.default('order');
//#endregion
//#region INITIAL STATE
const _initialState = Object.assign({ isFetching: 'STANDBY', wizardStep: 0, step2: {
        display: 'LIST',
        selectedDistributionLists: [],
        selectedRecipients: []
    }, step4: {
        additionalIsOpen: false,
        additionalInformation: ''
    }, values: {
        name: '',
        additionalOrderInformation: '',
        orderDate: undefined,
        distributionLists: [],
        orderRecipients: {},
        files: [],
        billingInformation: undefined,
        requestTimeOfDelivery: new Date().toISOString(),
        status: 'INITIAL',
        proceedWithoutInvalidFiles: false,
        modified: false,
        version: undefined
    }, isSaving: 'STANDBY', orderFilesStatus: 'STANDBY' }, orderFiles.initialState);
const initialState = () => JSON.parse(JSON.stringify(_initialState));
exports.initialState = initialState;
//#endregion
//#region LENS
const isFetchingLens = monocle.Lens.fromProp('isFetching');
const wizardStepLens = monocle.Lens.fromProp('wizardStep');
const isSavingLens = monocle.Lens.fromProp('isSaving');
const step2Lens = monocle.Lens.fromProp('step2');
const valuesLens = monocle.Lens.fromProp('values');
const checkingLens = monocle.Lens.fromProp('checkingFiles');
const orderFilesStatusLens = monocle.Lens.fromProp('orderFilesStatus');
const checkingFilesStatusLens = monocle.Lens.fromProp('status');
const checkingFilesFilesLens = monocle.Lens.fromProp('files');
const currentFrameLens = monocle.Lens.fromPath(['fileHistory', 'currentFrame']);
const historyLens = monocle.Lens.fromPath([
    'fileHistory',
    'history'
]);
const additionalIsOpenLens = monocle.Lens.fromPath(['step4', 'additionalIsOpen']);
const additionalInformationLens = monocle.Lens.fromPath(['step4', 'additionalInformation']);
const proceedWithoutInvalidFilesLens = monocle.Lens.fromProp('proceedWithoutInvalidFiles');
const modifiedLens = monocle.Lens.fromProp('modified');
// STEP 2
const step2DisplayLens = new monocle.Setter((display) => (state) => {
    const step2 = step2Lens.get(state);
    const nextDisplay = display(step2.display);
    if (nextDisplay === 'ADD_RECIPIENT') {
        return step2Lens.set({
            display: 'ADD_RECIPIENT',
            selected: [],
            addNewDeliveryAddress: false,
            tab: 0
        })(state);
    }
    else if (nextDisplay === 'ADD_DISTRIBUTION_LIST') {
        return step2Lens.set({
            display: 'ADD_DISTRIBUTION_LIST',
            selected: []
        })(state);
    }
    else {
        return step2Lens.set({
            display: 'LIST',
            selectedDistributionLists: [],
            selectedRecipients: []
        })(state);
    }
});
// LIST
const step2ListSelectedDistributionLists = new monocle.Optional((step2) => step2.display === 'LIST'
    ? fp.option.some(step2.selectedDistributionLists)
    : fp.option.none, (selectedDistributionLists) => (step2) => {
    if (step2.display === 'LIST') {
        return Object.assign(Object.assign({}, step2), { selectedDistributionLists });
    }
    return step2;
});
const step2ListSelectedRecipients = new monocle.Optional((step2) => step2.display === 'LIST'
    ? fp.option.some(step2.selectedRecipients)
    : fp.option.none, (selectedRecipients) => (step2) => {
    if (step2.display === 'LIST') {
        return Object.assign(Object.assign({}, step2), { selectedRecipients });
    }
    return step2;
});
// ADD_DISTRIBUTION_LIST
const step2AddDistributionListSelected = new monocle.Optional((step2) => step2.display === 'ADD_DISTRIBUTION_LIST'
    ? fp.option.some(step2.selected)
    : fp.option.none, (selected) => (step2) => {
    if (step2.display === 'ADD_DISTRIBUTION_LIST') {
        return Object.assign(Object.assign({}, step2), { selected });
    }
    return step2;
});
// ADD_RECIPIENT
const step2AddRecipientSelected = new monocle.Optional((step2) => step2.display === 'ADD_RECIPIENT'
    ? fp.option.some(step2.selected)
    : fp.option.none, (selected) => (step2) => {
    if (step2.display === 'ADD_RECIPIENT') {
        return Object.assign(Object.assign({}, step2), { selected });
    }
    return step2;
});
const step2AddRecipientAddNewDeliveryAddress = new monocle.Setter((value) => (step2) => {
    if (step2.display === 'ADD_RECIPIENT') {
        return Object.assign(Object.assign({}, step2), { addNewDeliveryAddress: value(step2.addNewDeliveryAddress) });
    }
    return step2;
});
const step2AddRecipientTab = new monocle.Setter((value) => (step2) => {
    if (step2.display === 'ADD_RECIPIENT') {
        return Object.assign(Object.assign({}, step2), { tab: value(step2.tab) });
    }
    return step2;
});
// VALUES
const valuesNameLens = monocle.Lens.fromProp('name');
const valuesDistributionListsLens = monocle.Lens.fromProp('distributionLists');
const valuesOrderRecipientsLens = monocle.Lens.fromProp('orderRecipients');
const valuesBillingInformationLens = monocle.Lens.fromProp('billingInformation');
const orderIdLens = monocle.Lens.fromProp('orderId');
const authorLens = monocle.Lens.fromProp('author');
const versionLens = monocle.Lens.fromProp('version');
const createdAtLens = monocle.Lens.fromProp('createdAt');
const valuesCustomBillingInformationFieldLens = (key, value) => monocle.Lens.fromProp(key).set(value);
const valuesRequestTimeOfDeliveryLens = monocle.Lens.fromProp('requestTimeOfDelivery');
const valuesStatusLens = monocle.Lens.fromProp('status');
const valuesErrorsLens = new monocle.Optional((v) => (v.status === 'ERROR' ? fp.option.some(v.errors) : fp.option.none), (errors) => (v) => {
    if (v.status === 'ERROR')
        return Object.assign(Object.assign({}, v), { errors });
    return v;
});
const methods = {};
exports.methods = methods;
methods[Actions.CLEAR_WIZARD] = () => (0, exports.initialState)();
// prevalidate
methods[orderFiles.ActionTypes.PREVALIDATE_FILES_REQUEST] = (state, action) => (Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.PREVALIDATE_FILES_REQUEST](state, action)));
methods[orderFiles.ActionTypes.PREVALIDATE_FILES_FAILURE] = (state, action) => (Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.PREVALIDATE_FILES_FAILURE](state, action)));
methods[orderFiles.ActionTypes.PREVALIDATE_FILES_SUCCESS] = (state, action) => (Object.assign(Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.PREVALIDATE_FILES_SUCCESS](state, action)), { isSaving: 'STANDBY', values: Object.assign(Object.assign({}, state.values), { modified: true }) }));
methods[orderFiles.ActionTypes.PREVALIDATE_IMPORTED_FILES_REQUEST] = (state, action) => (Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.PREVALIDATE_IMPORTED_FILES_REQUEST](state, action)));
methods[orderFiles.ActionTypes.PREVALIDATE_IMPORTED_FILES_FAILURE] = (state, action) => (Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.PREVALIDATE_IMPORTED_FILES_FAILURE](state, action)));
methods[orderFiles.ActionTypes.PREVALIDATE_IMPORTED_FILES_SUCCESS] = (state, action) => (Object.assign(Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.PREVALIDATE_IMPORTED_FILES_SUCCESS](state, action)), { isSaving: 'STANDBY', values: Object.assign(Object.assign({}, state.values), { modified: true }) }));
// prevalidate end
methods[Actions.VALIDATE_STEP_FAILURE] = (state, action) => fp.function.compose(isSavingLens.set('STANDBY'), valuesLens
    .asOptional()
    .compose(valuesErrorsLens)
    .set(action.payload.errors.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {})), valuesLens.compose(valuesStatusLens).set('ERROR'))(state);
methods[Actions.PROCEED_WITHOUT_INVALID_FILES] = (state, action) => valuesLens.compose(proceedWithoutInvalidFilesLens).modify((x) => !x)(state);
methods[Actions.VALIDATE_STEP_SUCCESS] = (state, action) => {
    return fp.function.compose(wizardStepLens.set(action.payload.wizardStep), valuesLens.compose(valuesStatusLens).set('INITIAL'), valuesLens.asOptional().compose(valuesErrorsLens).set({}))(state);
};
// STEP 2
methods[Actions.STEP2_CHANGE_DISPLAY] = (state, action) => step2DisplayLens.set(action.payload.display)(state);
methods[Actions.STEP2_LIST_SELECT_DISTRIBUTION_LIST] = (state, action) => step2Lens.modify(step2ListSelectedDistributionLists.modify((list) => action.payload.selected.reduce((r, i) => {
    if (r.indexOf(i) === -1)
        return [...r, i];
    return r;
}, list)))(state);
methods[Actions.STEP2_LIST_UNSELECT_DISTRIBUTION_LIST] = (state, action) => step2Lens.modify(step2ListSelectedDistributionLists.modify((list) => list.filter((id) => action.payload.unselected.indexOf(id) === -1)))(state);
methods[Actions.STEP2_LIST_SELECT_RECIPIENTS] = (state, action) => step2Lens.modify(step2ListSelectedRecipients.modify((list) => action.payload.selected.reduce((r, i) => {
    if (r.indexOf(i) === -1)
        return [...r, i];
    return r;
}, list)))(state);
methods[Actions.STEP2_LIST_UNSELECT_RECIPIENTS] = (state, action) => step2Lens.modify(step2ListSelectedRecipients.modify((list) => list.filter((id) => action.payload.unselected.indexOf(id) === -1)))(state);
methods[Actions.STEP2_ADD_DISTRIBUTION_LIST_SELECT] = (state, action) => step2Lens.modify(step2AddDistributionListSelected.modify((list) => action.payload.selected.reduce((r, i) => {
    if (r.indexOf(i) === -1)
        return [...r, i];
    return r;
}, list)))(state);
methods[Actions.STEP2_ADD_DISTRIBUTION_LIST_UNSELECT] = (state, action) => step2Lens.modify(step2AddDistributionListSelected.modify((list) => list.filter((id) => action.payload.unselected.indexOf(id) === -1)))(state);
methods[Actions.STEP2_ADD_RECIPIENT_SELECT] = (state, action) => step2Lens.modify(step2AddRecipientSelected.modify((list) => action.payload.selected.reduce((r, i) => {
    if (r.indexOf(i) === -1)
        return [...r, i];
    return r;
}, list)))(state);
methods[Actions.STEP2_ADD_RECIPIENT_UNSELECT] = (state, action) => step2Lens.modify(step2AddRecipientSelected.modify((list) => list.filter((id) => action.payload.unselected.indexOf(id) === -1)))(state);
methods[Actions.STEP2_ADD_RECIPIENT_ADD_NEW_DELIVERY_ADDRESS] = (state, action) => step2Lens.modify(step2AddRecipientAddNewDeliveryAddress.set(action.payload.addNewDeliveryAddress))(state);
methods[Actions.STEP2_ADD_RECIPIENT_TAB] = (state, action) => step2Lens.modify(step2AddRecipientTab.set(action.payload.tab))(state);
methods[orderFiles.ActionTypes.SELECT_FILES] = (state, action) => (Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.SELECT_FILES](state, action)));
methods[orderFiles.ActionTypes.UNSELECT_FILES] = (state, action) => (Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.UNSELECT_FILES](state, action)));
methods[orderFiles.ActionTypes.REMOVE_FILE] = (state, action) => (Object.assign(Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.REMOVE_FILE](state, action)), { isSaving: 'STANDBY', values: Object.assign(Object.assign({}, state.values), { modified: true }) }));
methods[orderFiles.ActionTypes.RESTORE_FILE] = (state, action) => (Object.assign(Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.RESTORE_FILE](state, action)), { isSaving: 'STANDBY', values: Object.assign(Object.assign({}, state.values), { modified: true }) }));
methods[orderFiles.ActionTypes.CHANGE_COLOR] = (state, action) => (Object.assign(Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.CHANGE_COLOR](state, action)), { isSaving: 'STANDBY', values: Object.assign(Object.assign({}, state.values), { modified: true }) }));
methods[orderFiles.ActionTypes.BROWSE] = (state, action) => (Object.assign(Object.assign(Object.assign({}, state), orderFiles.methods[orderFiles.ActionTypes.BROWSE](state, action)), { isSaving: 'STANDBY', values: Object.assign(Object.assign({}, state.values), { modified: true }) }));
//#region step4
methods[Actions.STEP4_TOGGLE] = (state, action) => additionalIsOpenLens.modify((x) => !x)(state);
methods[Actions.STEP4_SET_ADDITIONAL] = (state, action) => fp.function.compose(additionalInformationLens.set(action.payload.text), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
//#endregion
// VALUES
methods[Actions.VALUES_SET_NAME] = (state, action) => fp.function.compose(valuesLens.modify(valuesNameLens.set(action.payload.name)), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.VALUES_ADD_DISTRIBUTION_LISTS] = (state, action) => fp.function.compose(valuesLens.modify(valuesDistributionListsLens.modify((lists) => action.payload.distributionLists.reduce((r, i) => {
    if (!r.find(({ id }) => id === i.id))
        return [...r, i];
    return r;
}, lists))), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.VALUES_REMOVE_DISTRIBUTION_LISTS] = (state, action) => fp.function.compose(valuesLens.modify(valuesDistributionListsLens.modify((lists) => lists.filter((list) => !action.payload.distributionLists.find(({ id }) => id === list.id)))), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.VALUES_ADD_DISTRIBUTION_RECIPIENTS] = (state, action) => fp.function.compose(valuesLens.modify(valuesOrderRecipientsLens.modify((map) => action.payload.orderRecipients.reduce((r, recipient) => {
    const clone = Object.assign({}, r);
    if (recipient.uuid !== undefined) {
        clone[recipient.uuid] = recipient;
    }
    return clone;
}, map))), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.VALUES_REMOVE_DISTRIBUTION_RECIPIENT] = (state, action) => fp.function.compose(valuesLens.modify(valuesOrderRecipientsLens.modify((map) => {
    const clone = Object.assign({}, map);
    if (action.payload.uuid) {
        delete clone[action.payload.uuid];
    }
    return clone;
})), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.VALUES_SET_BILLING_INFORMATION] = (state, action) => {
    const selected = Object.assign({}, action.payload);
    if (selected.type === 'INTERNAL' &&
        selected.projects &&
        selected.projects.length === 1) {
        selected.selectedProject = selected.projects[0].id;
    }
    return fp.function.compose(valuesLens.modify(fp.function.compose(valuesBillingInformationLens.set(selected), modifiedLens.set(true))), isSavingLens.set('STANDBY'))(state);
};
methods[Actions.VALUES_UPDATE_CUSTOM_BILLING_INFORMATION_FIELD] = (state, action) => fp.function.compose(valuesLens.modify(valuesBillingInformationLens.modify(valuesCustomBillingInformationFieldLens(action.payload.key, action.payload.value))), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.VALUES_SET_REQUEST_TIME_OF_DELIVERY] = (state, action) => fp.function.compose(valuesLens.modify(fp.function.compose(valuesRequestTimeOfDeliveryLens.set(action.payload.value), modifiedLens.set(true))), isSavingLens.set('STANDBY'))(state);
methods[Actions.VALUES_CHANGE_DISTRIBUTION_RECIPIENT_QUANTITY] = (state, action) => fp.function.compose(valuesLens.modify(valuesOrderRecipientsLens.modify((recipients) => {
    const clone = Object.assign({}, recipients);
    if (clone[action.payload.uuid]) {
        clone[action.payload.uuid].quantity = action.payload.value;
    }
    return clone;
})), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.VALUES_CHANGE_DISTRIBUTION_RECIPIENT_FINISHING] = (state, action) => fp.function.compose(valuesLens.modify(valuesOrderRecipientsLens.modify((recipients) => {
    const clone = Object.assign({}, recipients);
    if (clone[action.payload.uuid]) {
        clone[action.payload.uuid].finishing = action.payload.value;
    }
    return clone;
})), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.VALUES_CHANGE_DISTRIBUTION_RECIPIENT_DELIVERY_METHOD] = (state, action) => fp.function.compose(valuesLens.modify(valuesOrderRecipientsLens.modify((recipients) => {
    const clone = Object.assign({}, recipients);
    if (clone[action.payload.uuid]) {
        clone[action.payload.uuid].deliveryMethod = action.payload.value;
    }
    return clone;
})), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.VALUES_CHANGE_DISTRIBUTION_RECIPIENT_PRINT_PROVIDER] = (state, action) => fp.function.compose(valuesLens.modify(valuesOrderRecipientsLens.modify((recipients) => {
    const clone = Object.assign({}, recipients);
    if (clone[action.payload.uuid]) {
        clone[action.payload.uuid].printProvider = action.payload.value;
    }
    return clone;
})), isSavingLens.set('STANDBY'), valuesLens.modify(modifiedLens.set(true)))(state);
methods[Actions.CREATE_NEW_ORDER_REQUEST] = (state, action) => {
    if (action.payload.type === 'AUTOMATIC_ORDER' &&
        action.payload.mode === 'SAVE') {
        return fp.function.compose(valuesLens.modify(valuesStatusLens.set('INITIAL')), isSavingLens.set('SAVING'))(state);
    }
    return isSavingLens.set('SAVING')(state);
};
methods[Actions.CREATE_NEW_ORDER_SUCCESS] = (state, action) => fp.function.compose((state) => {
    if (state.orderFilesStatus === 'STANDBY') {
        return orderFilesStatusLens.set('FETCHED')(state);
    }
    return state;
}, isSavingLens.set('SAVED'), isFetchingLens.set('FETCHED'), additionalInformationLens.set(action.payload.additionalInformation), checkingLens.compose(checkingFilesStatusLens).set('VALID'), valuesLens.modify(fp.function.compose((state) => {
    if (action.payload.billingInformation) {
        return valuesBillingInformationLens.set(action.payload.billingInformation)(state);
    }
    return state;
}, valuesNameLens.set(action.payload.name), authorLens.set(action.payload.author), orderIdLens.set(action.payload.id), versionLens.set(action.payload.version), createdAtLens.set(action.payload.createdAt), modifiedLens.set(false), proceedWithoutInvalidFilesLens.set(false))))(state);
methods[Actions.CREATE_NEW_ORDER_FAILED] = (state) => isSavingLens.set('FAILED')(state);
methods[Actions.SET_BILLING_INFORMATION_PROJECT] = (state, action) => valuesLens.modify(valuesBillingInformationLens.modify((x) => {
    if (x && x.type === 'INTERNAL') {
        return Object.assign(Object.assign({}, x), { selectedProject: action.payload.project.id });
    }
    return x;
}))(state);
methods[Actions.EXCLUDE_RECIPIENT] = (state, action) => valuesLens.modify(fp.function.compose(valuesDistributionListsLens.modify((lists) => lists.reduce((arr, i) => {
    const selected = i.recipients.find((x) => x.id === action.payload.id);
    if (selected) {
        selected.excluded = !selected.excluded;
    }
    arr.push(i);
    return arr;
}, [])), modifiedLens.set(true)))(state);
//#endregion
//#region edit order
methods[Actions.FETCH_ORDER_FILES_SUCCESS] = (state, action) => {
    const deleted = {};
    const colored = {};
    const hardDeleted = {};
    for (const file of action.data) {
        if (file.color === true || file.color === false) {
            colored[file.uuid] = file.color;
        }
        const parent = deleted[file.parentUuid];
        if (file.excluded !== false) {
            deleted[file.uuid] = parent || file.excluded || false;
        }
        else {
            deleted[file.uuid] = file.excluded || false;
        }
        if (deleted[file.parentUuid] === true && file.excluded !== false) {
            hardDeleted[file.uuid] = true;
        }
    }
    const newframe = {
        deleted,
        colored,
        hardDeleted
    };
    return fp.function.compose(isSavingLens.set('STANDBY'), orderFilesStatusLens.set('FETCHED'), valuesLens.modify(modifiedLens.set(false)), currentFrameLens.set(newframe), historyLens.set([newframe]), checkingLens.compose(checkingFilesFilesLens).set(action.data), checkingLens.compose(checkingFilesStatusLens).set('VALID'))(state);
};
methods[Actions.FETCH_ORDER_REQUEST] = (state, action) => fp.function.compose(isFetchingLens.set('FETCHING'), valuesLens.modify(orderIdLens.set(action.payload.id)))(state);
methods[Actions.FETCH_ORDER_FAILURE] = (state) => isFetchingLens.set('FAILED')(state);
methods[Actions.FETCH_ORDER_SUCCESS] = (state, action) => fp.function.compose(isFetchingLens.set('FETCHED'), additionalInformationLens.set(action.payload.additionalInformation), valuesLens.modify(fp.function.compose(action.payload.requestTimeOfDelivery
    ? valuesRequestTimeOfDeliveryLens.set(action.payload.requestTimeOfDelivery)
    : (x) => x, valuesBillingInformationLens.set(action.payload.billingInformation), valuesNameLens.set(action.payload.name), authorLens.set(action.payload.author), orderIdLens.set(action.payload.id), versionLens.set(action.payload.version), createdAtLens.set(action.payload.createdAt), modifiedLens.set(false))))(state);
methods[Actions.FETCH_RECIPIENTS_SUCCESS] = (state, action) => {
    // add identifier for orderRecipients
    const r = action.recipients;
    const distributionList = [];
    const recipients = {};
    Object.values(r).reduce((acc, x) => {
        if (x.distributionId) {
            const list = acc.distributionList.find((dl) => dl.id === x.distributionId);
            if (list) {
                list.recipients.push(x);
            }
            else {
                const dl = {
                    id: x.distributionId,
                    name: x.distributionName || '',
                    description: '',
                    recipients: [x],
                    project: '',
                    author: null,
                    createdAt: null,
                    modifiedAt: null
                };
                acc.distributionList.push(dl);
            }
        }
        else {
            acc.recipients[x.uuid] = x;
        }
        return acc;
    }, { distributionList, recipients });
    return valuesLens.modify(fp.function.compose(valuesOrderRecipientsLens.set(recipients), valuesDistributionListsLens.set(distributionList)))(state);
};
methods[Actions.FETCH_ORDER_FILES_REQUEST] = (state, action) => orderFilesStatusLens.set('FETCHING')(state);
methods[Actions.FETCH_ORDER_FILES_FAILURE] = (state, action) => orderFilesStatusLens.set('FAILED')(state);
//# sourceMappingURL=wizard.js.map